import React, { useEffect, useState, useMemo } from "react";
import { FiFileText } from "react-icons/fi";
import api from "../../../api";
import { formatDate } from "../../../utils"
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FiGrid } from "react-icons/fi";
// import './css/admin-formalities.css';
import FormalitiesRequestsFilter from 'components/formalities/helpers/FormalitiesRequestsFilter';
import AdminFormalitiesRequestsList from 'components/formalities/admin/AdminFormalitiesRequestsList';
export default function AdminPageFormalitiesRequestsList() {
  const [requests, setRequests] = useState([]);
  const [users, setUsers] = useState({});
  const [searchParams] = useSearchParams();
  const [templates, setTemplates] = useState({});
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("all");
  const [monthFilter, setMonthFilter] = useState('');
  const navigate = useNavigate();
  const config = useSelector((state) => state.config);
  const statuses = config?.formalities?.requests?.status || {};
  const { t } = useTranslation();
  useEffect(() => {
    const urlStatus = searchParams.get("status");
    if (urlStatus && statuses[urlStatus]) {
      setStatusFilter(urlStatus);
    }
  }, [searchParams, statuses]);
  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get("/admin/formalities/requests");
        setRequests(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        console.error("LOAD REQUESTS ERROR", e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);
  const onStatusChange = (status) => {
    setStatusFilter(status);
    if (status === "all") {
      navigate("/admin/formalities/requests/list");
    } else {
      navigate(`/admin/formalities/requests/list?status=${status}`, {
        replace: true
      });
    }
  };
  const normalize = (str = "") =>
    str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  const filtered = useMemo(() => {
    let items = [...requests];
    // ----------------------------------------------------
    // 1. Filtre par statut
    // ----------------------------------------------------
    if (statusFilter !== "all") {
      items = items.filter((r) => r.frStatus === statusFilter);
    }
    if (monthFilter && monthFilter !== "") { // 2025-11
      items = items.filter(r => r.frCreatedAt.startsWith(monthFilter));
    }
    // ----------------------------------------------------
    // 2. Filtre par texte (insensible casse + accents)
    // ----------------------------------------------------
    if (search.trim()) {
      const s = normalize(search);
      items = items.filter((r) => {
        const template = templates[r.templateKey];
        const title = template?.title || template?.name || "";
        const id = normalize(r.frId || "");
        const t = normalize(title);
        const userName = normalize(
          r.user?.userName ||
          `${r.user?.firstName || ""} ${r.user?.lastName || ""}`
        );
        const compName = normalize(r.user?.userCompName || "");
        return (
          id.includes(s) ||
          t.includes(s) ||
          userName.includes(s) ||
          compName.includes(s)
        );
      });
    }
    return items;
  }, [search, statusFilter, monthFilter, requests, templates]);
  const openRequest = (req) => {
    navigate(`/admin/formalities/request/${req.frId}`);
  };
  return (
    <div id="admin-formalities-requests-list" className="py-4 container-fluid">
      <div class="d-flex justify-content-between align-items-end mb-4 ">
        <h1 class="h4 m-0"><span>Demandes de formalités</span></h1>
        <div className="">
          <Link to="/admin">
            <FiGrid size={20} className="text-primary" />
          </Link>
        </div>
      </div>
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-3">
        </div>
        <div className="mb-3">
          <FormalitiesRequestsFilter
            search={search}
            onSearchChange={setSearch}
            monthFilter={monthFilter}
            onMonthChange={setMonthFilter}
            statuses={statuses}
            statusFilter={statusFilter}
            onStatusChange={onStatusChange}
          />

        </div>
        <div className="mb-3">
          <AdminFormalitiesRequestsList
            requests={filtered}
            loading={loading}
            statuses={statuses}
          />
        </div>
      </div>
    </div >
  );
}
